////////// env start //////////
export const _api_host = 'http://localhost:8000';
export const _bam_domain = 'http://localhost:5000/#';
////////// env end //////////